<template>
  <div>
    <b-container>
      <b-row class="py-4">
        <b-col
          :cols="5"
          class="text-center"
        >
          <b-img
            fluid
            :src="match.team1.image_url"
            :class="$style.teamImage"
            rounded="circle"
          />
        </b-col>
        <b-col
          :cols="2"
          class="d-flex flex-column align-items-center justify-content-center text-center"
        >
          {{ startDate }}
          {{ startTime }}
          <span
            v-if="match.location"
            class="pt-4"
          >
            {{ match.location[$i18n.locale] }}
          </span>
        </b-col>
        <b-col
          :cols="5"
          class="text-center"
        >
          <b-img
            fluid
            :src="match.team2.image_url"
            :class="$style.teamImage"
            rounded="circle"
          />
        </b-col>

        <b-col
          :cols="5"
          class="text-center"
        >
          <span :class="$style.teamName">
            {{ match.team1.display_name[$i18n.locale] }}
            <span :class="$style.fullTeamName">
              {{ match.team1.name[$i18n.locale] }}
            </span>
          </span>
        </b-col>
        <b-col :cols="2" />
        <b-col
          :cols="5"
          class="text-center"
        >
          <span :class="$style.teamName">
            {{ match.team2.display_name[$i18n.locale] }}
            <span :class="$style.fullTeamName">
              {{ match.team2.name[$i18n.locale] }}
            </span>
          </span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'TheSummerMatchOverview',
  components: {
  },
  props: {
    match: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    startDate() {
      return format(this.match.start, 'DD/MM/YY')
    },
    startTime() {
      return format(this.match.start, 'HH:mm')
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .teamImage {
    max-height: 175px;
  }
  .teamName {
    display: block;
    padding: 1rem 0;
    color: $color-midnight-blue;
    font-size: $font-size-xlarge;
    .fullTeamName {
      display: block;
      font-size: $font-size-small;
    }
  }
</style>
